import { createAction } from 'redux-actions'
import _ from 'lodash'
import Cookies from 'universal-cookie'
const prefix = 'GeoPicker plugin:'

export const SET_GEO_PREFERENCE = `${prefix} Set geo preference`

const setGeoPreferenceAction = createAction(SET_GEO_PREFERENCE)

const setGeoPreference = (query, shouldSaveCookie = true) => (dispatch) => {
  const cookies = new Cookies()
  const geoQuery = _.pick(query, ['r', 'm', 'ag', 'sa'])
  if (shouldSaveCookie) {
    cookies.set('geoPref', geoQuery, {
      path: '/',
      maxAge: 3153600000, // 60 * 60 * 24 * 365 * 100,
      httpOnly: false,
    })
  }

  return dispatch(setGeoPreferenceAction(geoQuery))
}

export const actionCreators = {
  setGeoPreference,
}
